import { useTranslation } from "react-i18next";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import { useState } from "react";
import instance from "../../../Interceptor/api_instance";
import FormButtons from "../../../Components/Buttons/FormButtons";

const UploadFile = ({ reference, close, setData }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    reference_id: reference.id,
    reference_model: reference.model,
    blob_type: reference.blob_type,
    container_name: "documents",
  });

  const { mutate, isLoading, error } = useApiMutation(async () => {
    const data = new FormData();
    data.append("files", formData.file);
    data.append("data", JSON.stringify(formData));
    const res = await instance.post("/files/blobs/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (res.status === 201) {
      if (setData) {
        setData(res.data[0]);
      }
      close();
    }
    return res;
  });

  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        <h2 className="global-h2">Upload File</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            mutate();
          }}
        >
          <div className="form-block">
            <label className="required">Browse...</label>
            <input
              type="file"
              onChange={(e) =>
                setFormData({ ...formData, file: e.target.files[0] })
              }
            />
          </div>
          <FormButtons onCancel={close} isLoading={isLoading} />
        </form>
      </div>
    </div>
  );
};

export default UploadFile;
